import { capitalize } from './misc'

const adjectives = {
    easy: [
        'tame',
        'friendly',
        'hopeful',
        'brief',
        'lucky',
        'blissful',
        'adorable',
        'nice',
        'well meaning',
        'agreeable',
        'calm',
        'careless',
        'relaxed',
        'breathless',
        'cute',
        'blue eyed'
    ],
    medium: [
        'aspiring',
        'cheerful',
        'cooperative',
        'eager',
        'capable',
        'secretive',
        'lovely',
        'speedy',
        'gentle',
        'witty',
        'faint',
        'whispering',
        'cozy',
        'happy',
        'fresh',
        'fancy',
        'prickly',
        'non allergic'
    ],
    hard: [
        'bold',
        'fierce',
        'modern',
        'bountiful',
        'courageous',
        'brainy',
        'alluring',
        'careful',
        'brave',
        'lively',
        'wooden',
        'uneven',
        'pickled',
        'flaky',
        'scarce',
        'numeric',
        'ragged',
        'covert'
    ],
    expert: [
        'murky',
        'strange',
        'crooked',
        'outstanding',
        'fearless',
        'passionate',
        'outrageous',
        'mysterious',
        'sizable',
        'incalculable',
        'substantial',
        'sparse',
        'algorithmic',
        'ingenious',
        'interesting',
        'draconian',
        'glorious',
        'major',
        'obscure'
    ],
    artisan: [
        'artisanal',
        'futuristic',
        'irregular',
        'defiant',
        'determined',
        'diligent',
        'cumbersome',
        'majestic',
        'astonishing',
        'indescribable',
        'incomparable',
        'prestigious',
        'malnourished',
        'inexplicable',
        'wondrous',
        'immovable',
        'fortified',
        'bothersome',
        'concealed'
    ],
    master: [
        'vast',
        'great',
        'masterful',
        'eternal',
        'astronomical',
        'enchanting',
        'erratic',
        'massive',
        'divine',
        'unnatural',
        'dark',
        'impenetrable',
        'elusive',
        'epic',
        'absurd',
        'great',
        'immortal',
        'perfected',
        'engineered',
        'gigantic',
        'veiled'
    ],
    jedi: [
        'incredulous',
        'forceful',
        'ominous',
        'immense',
        'combative',
        'disastrous',
        'ruthless',
        'imperial',
        'biblical',
        'awe inspiring',
        'terror inducing',
        'insurmountable',
        'unfathomable',
        'mind bending',
        'malicious',
        'measureless',
        'boundless',
    ]
}

const subject = {
    easy: [
        'teddy bear',
        'child',
        'companion',
        'old lady',
        'gungan',
        'disney character',
        'mouse',
        'cat',
        'neighbor',
        'friend',
        'farm animal',
        'pokemon',
        'dog',
        'musician',
        'coffee cup',
        'soda bottle'
    ],
    medium: [
        'colleague',
        'buddy',
        'do-gooder',
        'rain forrest',
        'orangutan',
        'meerkat',
        'swimming pool',
        'loud speaker',
        'pillow',
        'blanket',
        'rain forrest',
        'willow tree',
        'broomstick',
        'pyjamas',
        'birthday cake',
        'hitch hiker',
        'forrest canopy',
        'sloth',
        'cuisine',
    ],
    hard: [
        'candidate',
        'middle manager',
        'gang member',
        'entrance',
        'columns',
        'vessel',
        'vehicle',
        'lion',
        'elephant',
        'cheetah',
        'coral reef',
        'engineer',
        'barracks',
        'house',
        'coil',
        'equipment',
        'gadget',
        'person of interest',
        'shell',
        'gorilla'
    ],
    expert: [
        'skyscraper',
        'sea creature',
        'board of executives',
        'stadium',
        'detective',
        'commission',
        'adventure',
        'legend',
        'catacomb',
        'craftsman',
        'spell',
        'problem',
        'ransom',
        'cathedral',
        'hall',
        'myth',
        'investigator',
        'quest',
        'wood elf'
    ],
    artisan: [
        'sea monster',
        'executive officer',
        'admiral',
        'hydrogen blimp',
        'president',
        'warden',
        'alien',
        'space ship',
        'ghost',
        'emperor',
        'dictator',
        'creature',
        'mind',
        'eyes',
        'spirit',
        'diamond',
        'fire',
        'fortress',
        'bunker'
    ],
    master: [
        'mountain',
        'ocean',
        'volcano',
        'earthquake',
        'tsunami',
        'avalanche',
        'eruption',
        'hurricane',
        'lightning',
        'prisoner',
        'antagonist',
        'power bolt',
        'moon',
        'aurora',
        'aftermath',
        'energy'
    ],
    jedi: [
        'sith lord',
        'universe',
        'solar system',
        'galaxy',
        'solar storm',
        'super nova',
        'black hole',
        'hero killer',
        'chasm',
        'tomb',
        'omen',
        'dreamscape',
        'dimension',
        'destiny',
        'force',
        'ascension',
        'light'
    ]
}

const rand = (n: number) => Math.floor((Math.random()*n))

export const generateName = (difficulty: string) => {
    return [
        capitalize(adjectives[difficulty][rand(adjectives[difficulty].length)]),
        subject[difficulty][rand(subject[difficulty].length)],
    ].join(' ')
}